/**
 * Remise volume multi-enseignes — MIROIR de /app/backend/pricing.py.
 * Grille A (validée client) :
 *   ≥ 3 000 CHF → -3 %
 *   ≥ 6 000 CHF → -5 %
 *   ≥ 10 000 CHF → -8 %
 * Appliquée automatiquement sur le sous-total HT du panier consolidé.
 */

export const VOLUME_DISCOUNT_TIERS = [
  { threshold: 10000, rate: 0.08 },
  { threshold: 6000, rate: 0.05 },
  { threshold: 3000, rate: 0.03 },
];

/**
 * @param {number} subtotalChf - Sous-total HT en CHF (avant remise)
 * @returns {{
 *   subtotal: number,
 *   discountRate: number,       // 0 | 0.03 | 0.05 | 0.08
 *   discountAmount: number,     // CHF entier
 *   netTotal: number,           // subtotal - discountAmount
 *   nextTier: null | { threshold: number, rate: number, missing: number },
 * }}
 */
export function computeVolumeDiscount(subtotalChf) {
  const subtotal = Math.max(0, Math.round(Number(subtotalChf) || 0));
  let rate = 0;
  for (const tier of VOLUME_DISCOUNT_TIERS) {
    if (subtotal >= tier.threshold) {
      rate = tier.rate;
      break;
    }
  }
  const discountAmount = Math.round(subtotal * rate);
  const ascending = [...VOLUME_DISCOUNT_TIERS].sort((a, b) => a.threshold - b.threshold);
  let nextTier = null;
  for (const tier of ascending) {
    if (subtotal < tier.threshold) {
      nextTier = {
        threshold: tier.threshold,
        rate: tier.rate,
        missing: tier.threshold - subtotal,
      };
      break;
    }
  }
  return {
    subtotal,
    discountRate: rate,
    discountAmount,
    netTotal: subtotal - discountAmount,
    nextTier,
  };
}
